import React from 'react';
import PropTypes from 'prop-types';

import { GET_STARTED_TITLE } from '../constants';

/**
 * Shared sub-task header
 * @param {String} [title] - optional page specific h2
 * @returns {JSX}
 */
const SubTaskContainerHeader = ({ title }) => {
  return (
    <div className="vads-u-margin-bottom--3">
      <h1 className="vads-u-margin-bottom--0">{GET_STARTED_TITLE}</h1>
      <p className="vads-u-margin-top--1 vads-u-margin-bottom--0 vads-u-font-family--sans vads-u-font-weight--normal vads-u-font-size--lg vads-u-line-height--4">
        Application for Disability Compensation and Related Compensation
        Benefits (VA Form 21-526EZ)
      </p>
      {title ? <h2 className="vads-u-margin-top--3">{title}</h2> : null}
    </div>
  );
};

SubTaskContainerHeader.propTypes = {
  title: PropTypes.string,
};

export default SubTaskContainerHeader;
